const UNITS_OF_TIME = Object.freeze({
  //
  // large units of time
  lg: Object.freeze({
    y: 'years',
    m: 'months',
    w: 'weeks',
    d: 'days',
  }),

  // medium units of time
  md: Object.freeze({
    h: 'hours',
    m: 'minutes',
    s: 'seconds',
  }),

  // small units of time
  sm: Object.freeze({
    m: 'milliseconds',
  }),
  //
});

export default UNITS_OF_TIME;
